var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ColorCard",style:({
        background: 'linear-gradient(to right, '+_vm.pcolor.blcolor+', '+_vm.pcolor.brcolor+')'})},[_c('div',{staticClass:"box"},[_c('span',{style:({color: _vm.pcolor.color})},[_vm._v(_vm._s(_vm.pdata[0]))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('span',[_vm._v(_vm._s(_vm.pdata[1]))])]),_vm._v(" "),_c('div',{staticClass:"mask"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378b61c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/map/cityList/ColorCard.vue
// module id = xP83
// module chunks = 0